import clsx from 'clsx';
import React from 'react';
import Button from './Button';

function PageHeader({ heading, description, children, fullWidth, className, docsLink, rightAction }) {
  return (
    <div>
      <div className={clsx('bg-gray-900 pt-10 pb-10', { 'mb-16': !docsLink }, className)}>
        <div className={clsx('px-4 mx-auto lg:px-8', { 'max-w-7xl': !fullWidth })}>
          <div className='flex lg:flex-row flex-col gap-10 lg:gap-3 lg:justify-between'>
            <div>
              <h1 className='text-2xl font-extrabold text-neutral-200 sm:text-4xl xl:text-6xl'>{heading}</h1>

              <div className='max-w-xl mt-4'>
                <p className='text-base text-neutral-400 md:text-xl'>{description}</p>
                {!!children && <div className='mt-6'>{children}</div>}
              </div>
            </div>
            {docsLink && (
              <div className='flex justify-end lg:items-end'>
                <Button theme='none' href={docsLink} target='_blank' className='flex items-center gap-3 text-white'>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' className='w-[20px]'>
                    <path
                      d='M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z'
                      fill='currentColor'
                    />
                  </svg>
                  <span className='md:text-lg font-bold'>How does it work?</span>
                </Button>
              </div>
            )}

            {rightAction && <div className='flex w-full md:w-auto md:justify-end lg:items-end'>{rightAction}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
